import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api, API_BASE_URL } from '../lib/api.ts';

export function LoginPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [tab, setTab] = useState<'oauth' | 'pat'>('oauth');
  const [gitlabToken, setGitlabToken] = useState('');

  const mutation = useMutation({
    mutationFn: api.saveCredentials,
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['session'] });
      navigate('/repos');
    },
  });

  const errorMessage = (() => {
    if (!mutation.error) return null;
    try {
      const json = JSON.parse((mutation.error as Error).message.replace(/^HTTP \d+: /, ''));
      if (Array.isArray(json)) return json[0]?.message ?? (mutation.error as Error).message;
      return json.message ?? (mutation.error as Error).message;
    } catch {
      return (mutation.error as Error).message;
    }
  })();

  return (
    <div style={{ maxWidth: 520, margin: '40px auto' }}>
      <div className="panel col">
        <h2 style={{ marginTop: 0 }}>Connexion Clearflow</h2>
        <p className="muted">
          Entre ton token d'accès GitLab. Il est chiffré AES-256 côté serveur avant stockage. Le
          token Jira se configure séparément, une fois connecté (menu utilisateur → Paramètres).
        </p>

        <div className="tabs">
          <button
            className={`tab-button${tab === 'oauth' ? ' active' : ''}`}
            onClick={() => setTab('oauth')}
          >
            GitLab OAuth
          </button>
          <button
            className={`tab-button${tab === 'pat' ? ' active' : ''}`}
            onClick={() => setTab('pat')}
          >
            PAT manuel
          </button>
        </div>

        {tab === 'oauth' && (
          <div className="row" style={{ marginTop: 12, justifyContent: 'center' }}>
            <a className="button" href={`${API_BASE_URL}/auth/gitlab/start`}>
              Se connecter
            </a>
          </div>
        )}

        {tab === 'pat' && (
          <>
            <h3>GitLab (PAT manuel)</h3>
            <label className="col" style={{ gap: 4 }}>
              <span>Personal Access Token (scope <code>api, read_repository</code>)</span>
              <input
                type="password"
                name="gitlab-pat"
                autoComplete="current-password"
                value={gitlabToken}
                onChange={(e) => setGitlabToken(e.target.value)}
                placeholder="glpat-..."
              />
            </label>

            <div className="row" style={{ marginTop: 12, justifyContent: 'center' }}>
              <button
                disabled={!gitlabToken || mutation.isPending}
                onClick={() => mutation.mutate({ gitlabToken })}
              >
                {mutation.isPending ? 'Enregistrement...' : 'Se connecter'}
              </button>
              {mutation.isError && (
                <div
                  className="modal-backdrop"
                  onClick={(e) => { if (e.target === e.currentTarget) mutation.reset(); }}
                  onKeyDown={(e) => { if (e.key === 'Escape') mutation.reset(); }}
                >
                  <div className="modal" style={{ maxWidth: 420 }}>
                    <h3 style={{ marginTop: 0, color: 'var(--danger)' }}>Erreur de connexion</h3>
                    <p>{errorMessage}</p>
                    <div style={{ marginTop: 16, textAlign: 'right' }}>
                      <button onClick={() => mutation.reset()}>Fermer</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
